export const projectCategories = [
  { id: 'all', name: 'Todos os Projetos' },
  { id: 'saude', name: 'Saúde' },
  { id: 'educacao', name: 'Educação' },
  { id: 'institucional', name: 'Institucional' },
  { id: 'comercial', name: 'Comercial' }
];

export const projects = [
  {
    id: 1,
    title: 'Hospital Central de Lisboa',
    category: 'saude',
    description: 'Sistema de iluminação LED completo para enfermarias, salas de cirurgia e áreas comuns. Soluções que priorizam o conforto dos pacientes e eficiência energética.',
    image: 'https://images.unsplash.com/photo-1571440727633-ca6b05da2008',
    year: '2024',
    location: 'Lisboa, Portugal',
    duration: '8 meses',
    client: 'Hospital Central de Lisboa',
    area: '15.000 m²',
    budget: '€450.000',
    fullDescription: 'Projeto completo de retrofit de iluminação para todas as áreas do Hospital Central de Lisboa. O desafio incluiu a necessidade de trabalhar em ambiente hospitalar operacional, garantindo zero interrupções nos serviços médicos. Implementamos tecnologia LED de última geração com controlo inteligente que se adapta às necessidades de cada área.',
    challenge: 'Trabalhar em ambiente hospitalar 24/7 sem interromper operações críticas e garantir iluminação adequada para diferentes áreas (cirúrgicas, enfermarias, corredores).',
    solution: 'Implementação faseada com trabalhos noturnos, uso de painéis LED com CRI >90 para áreas críticas e sistema de controlo DALI para gestão centralizada.',
    materials: [
      { name: 'Painéis LED Cirúrgicos', quantity: '120 unidades', specs: 'CRI >95, 5000K, Dimmerizável' },
      { name: 'Luminárias LED Enfermarias', quantity: '450 unidades', specs: 'CRI >90, 4000K, Sensor presença' },
      { name: 'Iluminação Emergência', quantity: '280 unidades', specs: 'Autonomia 3h, Bateria LiFePO4' },
      { name: 'Sistema Controlo DALI', quantity: '1 sistema', specs: 'Gestão centralizada, App móvel' },
      { name: 'Downlights LED Corredores', quantity: '350 unidades', specs: '3000K, IP54, Anti-vandalismo' }
    ],
    results: [
      'Redução de 68% no consumo energético',
      'Melhoria na satisfação dos pacientes em 42%',
      'Zero acidentes durante instalação',
      'ROI estimado em 4.2 anos'
    ],
    images: [
      'https://images.unsplash.com/photo-1571440727633-ca6b05da2008',
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d',
      'https://images.unsplash.com/photo-1538108149393-fbbd81895907',
      'https://images.unsplash.com/photo-1516549655169-df83a0774514',
      'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133'
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 2,
    title: 'Universidade do Porto - Campus Ciências',
    category: 'educacao',
    description: 'Iluminação inteligente para salas de aula, laboratórios e bibliotecas. Sistema de controlo automático com sensores de presença e luz natural.',
    image: 'https://images.unsplash.com/photo-1659612534697-3edc1892db46',
    year: '2023',
    location: 'Porto, Portugal',
    duration: '6 meses',
    client: 'Universidade do Porto',
    area: '12.000 m²',
    budget: '€320.000',
    fullDescription: 'Modernização completa do sistema de iluminação do Campus de Ciências da Universidade do Porto. O projeto integrou tecnologia de sensores de luz natural e presença para otimizar o consumo energético sem comprometer a qualidade de iluminação necessária para atividades académicas e de investigação.',
    challenge: 'Garantir níveis de iluminação adequados para diferentes atividades (aulas, laboratórios, estudo) com máxima eficiência energética.',
    solution: 'Sistema inteligente com sensores de luz natural que ajustam automaticamente a intensidade, combinado com controlo por zonas e agendamento horário.',
    materials: [
      { name: 'Painéis LED Salas Aula', quantity: '280 unidades', specs: '4000K, Dimmerizável, CRI >85' },
      { name: 'Iluminação Técnica Laboratórios', quantity: '95 unidades', specs: '5000K, CRI >90, IP54' },
      { name: 'Pendentes LED Biblioteca', quantity: '150 unidades', specs: '3500K, Design moderno' },
      { name: 'Sensores Presença/Luz Natural', quantity: '340 unidades', specs: 'Wireless, Integração KNX' },
      { name: 'Sistema Gestão BMS', quantity: '1 sistema', specs: 'Controlo centralizado, Relatórios' }
    ],
    results: [
      'Redução de 71% no consumo energético',
      'Melhoria na produtividade dos alunos',
      'Certificação LEED Gold',
      'Poupança anual de €48.000'
    ],
    images: [
      'https://images.unsplash.com/photo-1659612534697-3edc1892db46',
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1',
      'https://images.unsplash.com/photo-1541339907198-e08756dedf3f',
      'https://images.unsplash.com/photo-1562774053-701939374585',
      'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45'
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 3,
    title: 'Centro Cultural de Braga',
    category: 'institucional',
    description: 'Solução de iluminação cênica e arquitetônica para auditório principal, galerias de exposição e espaços públicos.',
    image: 'https://images.unsplash.com/photo-1708172180685-91cbd7dff647',
    year: '2024',
    location: 'Braga, Portugal',
    duration: '10 meses',
    client: 'Câmara Municipal de Braga',
    area: '8.500 m²',
    budget: '€680.000',
    fullDescription: 'Projeto ambicioso que combinou iluminação arquitetônica externa, iluminação cênica para o auditório de 800 lugares, e iluminação ajustável para as galerias de exposição. Cada espaço foi projetado para criar atmosferas únicas enquanto mantém flexibilidade para diferentes eventos e exposições.',
    challenge: 'Criar um sistema versátil que atenda necessidades muito distintas: performances teatrais, exposições de arte e eventos corporativos.',
    solution: 'Sistema modular com controlo DMX para iluminação cênica, track lights ajustáveis nas galerias e iluminação RGB para fachadas, tudo integrado numa plataforma centralizada.',
    materials: [
      { name: 'Projetores Cênicos LED', quantity: '85 unidades', specs: 'RGB+W, 200W, DMX512' },
      { name: 'Track Lights Galeria', quantity: '180 unidades', specs: 'CRI >95, Ajustável 15-40°' },
      { name: 'Wash Lights Fachada', quantity: '64 unidades', specs: 'RGB, IP65, 120W' },
      { name: 'Sistema Controlo DMX', quantity: '1 sistema', specs: 'Software profissional, 512 canais' },
      { name: 'Iluminação Arquitetônica', quantity: '125 unidades', specs: 'LED embutido, 3000K' }
    ],
    results: [
      'Premiado com Menção Honrosa - Design Iluminação 2024',
      'Redução de 58% nos custos operacionais',
      'Aumento de 35% na reserva de eventos',
      'Destaque internacional em revista de arquitetura'
    ],
    images: [
      'https://images.unsplash.com/photo-1708172180685-91cbd7dff647',
      'https://images.unsplash.com/photo-1514933651103-005eec06c04b',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
      'https://images.unsplash.com/photo-1478147427282-58a87a120781',
      'https://images.unsplash.com/photo-1509537257950-20f9d37c3b02'
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 4,
    title: 'Escola Secundária de Coimbra',
    category: 'educacao',
    description: 'Retrofit completo de iluminação com tecnologia LED de última geração. Redução de 65% no consumo energético.',
    image: 'https://images.unsplash.com/photo-1767294273869-d7d15bc5f80d',
    year: '2023',
    location: 'Coimbra, Portugal',
    duration: '4 meses',
    client: 'Ministério da Educação',
    area: '9.200 m²',
    budget: '€185.000',
    fullDescription: 'Projeto de retrofit que transformou completamente a iluminação da Escola Secundária de Coimbra, substituindo 100% das luminárias fluorescentes antigas por tecnologia LED. O projeto foi executado durante o período de férias escolares para minimizar perturbações.',
    challenge: 'Prazo apertado (férias de verão) e necessidade de trabalhar com infraestrutura elétrica antiga.',
    solution: 'Planeamento detalhado com equipa alargada, trabalho em turnos prolongados e upgrade seletivo da infraestrutura elétrica.',
    materials: [
      { name: 'Painéis LED Salas Aula', quantity: '185 unidades', specs: '4000K, 40W, CRI >80' },
      { name: 'Luminárias LED Corredores', quantity: '120 unidades', specs: '4000K, Sensor movimento' },
      { name: 'Projetores LED Exterior', quantity: '32 unidades', specs: '5000K, IP65, 100W' },
      { name: 'Luminárias LED Ginásio', quantity: '28 unidades', specs: 'IP44, Anti-impacto' },
      { name: 'Iluminação Emergência', quantity: '95 unidades', specs: 'Autonomia 3h' }
    ],
    results: [
      'Redução de 65% no consumo energético',
      'Poupança anual de €32.000',
      'Melhoria na qualidade de iluminação',
      'Projeto concluído 5 dias antes do prazo'
    ],
    images: [
      'https://images.unsplash.com/photo-1767294273869-d7d15bc5f80d',
      'https://images.unsplash.com/photo-1580582932707-520aed937b7b',
      'https://images.unsplash.com/photo-1503676260728-1c00da094a0b',
      'https://images.unsplash.com/photo-1497633762265-9d179a990aa6',
      'https://images.unsplash.com/photo-1509062522246-3755977927d7'
    ],
    video: null
  },
  {
    id: 5,
    title: 'Sede Câmara Municipal - Aveiro',
    category: 'institucional',
    description: 'Iluminação monumental para fachadas e iluminação funcional para escritórios administrativos.',
    image: 'https://images.unsplash.com/photo-1771239048280-0724031de3a4',
    year: '2024',
    location: 'Aveiro, Portugal',
    duration: '7 meses',
    client: 'Câmara Municipal de Aveiro',
    area: '11.000 m²',
    budget: '€520.000',
    fullDescription: 'Projeto que combinou iluminação funcional de alta eficiência para os escritórios administrativos com iluminação arquitetônica monumental para a fachada histórica do edifício. O desafio incluiu preservar a integridade do edifício classificado enquanto implementava tecnologia moderna.',
    challenge: 'Trabalhar em edifício histórico classificado com restrições de intervenção e necessidade de aprovação de entidades patrimoniais.',
    solution: 'Soluções não invasivas com fixações reversíveis, luminárias discretas e cablagem oculta que respeitam a arquitetura original.',
    materials: [
      { name: 'Wash Lights Fachada', quantity: '48 unidades', specs: 'RGB+W, IP65, Controlo DMX' },
      { name: 'Painéis LED Escritórios', quantity: '320 unidades', specs: '4000K, UGR<19' },
      { name: 'Luminárias Suspensas Átrio', quantity: '12 unidades', specs: 'Design premium, Dimmerizável' },
      { name: 'Spots LED Salas Reunião', quantity: '85 unidades', specs: 'Ajustável, CRI>90' },
      { name: 'Sistema Gestão Smart', quantity: '1 sistema', specs: 'Controlo horário, Cenários' }
    ],
    results: [
      'Valorização do património arquitetônico',
      'Redução de 62% no consumo energético',
      'Reconhecimento ICOMOS',
      'Atração turística noturna'
    ],
    images: [
      'https://images.unsplash.com/photo-1771239048280-0724031de3a4',
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab',
      'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2',
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174'
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 6,
    title: 'Centro Comercial NorteShopping',
    category: 'comercial',
    description: 'Sistema de iluminação dinâmica para corredores, lojas âncora e praça de alimentação com controlo centralizado.',
    image: 'https://images.unsplash.com/photo-1589173956121-8891103b66b0',
    year: '2023',
    location: 'Matosinhos, Portugal',
    duration: '9 meses',
    client: 'Sonae Sierra',
    area: '45.000 m²',
    budget: '€1.200.000',
    fullDescription: 'O maior projeto de iluminação comercial em Portugal em 2023. Implementamos um sistema dinâmico que adapta a iluminação ao longo do dia, criando diferentes atmosferas e aumentando o conforto dos visitantes enquanto otimiza o consumo energético.',
    challenge: 'Manter o centro comercial operacional durante todo o projeto e coordenar com mais de 150 lojistas.',
    solution: 'Trabalhos noturnos faseados por setor, comunicação proativa com lojistas e sistema de iluminação temporária durante intervenções.',
    materials: [
      { name: 'Track Lights Corredores', quantity: '850 unidades', specs: '3000K-5000K variável' },
      { name: 'Pendentes Design Praça Alimentação', quantity: '240 unidades', specs: 'Decorativos, Dimmerizável' },
      { name: 'Iluminação Linear LED', quantity: '2.400m', specs: 'Perfil contínuo, IP40' },
      { name: 'Projetores Loja Âncora', quantity: '180 unidades', specs: 'CRI>90, Ajustável' },
      { name: 'Sistema Gestão BMS', quantity: '1 sistema', specs: 'Integração total, Dashboard' }
    ],
    results: [
      'Aumento de 18% no tempo médio de permanência',
      'Redução de 54% no consumo energético',
      'Melhoria na satisfação dos visitantes',
      'Prémio Melhor Projeto Iluminação Comercial 2023'
    ],
    images: [
      'https://images.unsplash.com/photo-1589173956121-8891103b66b0',
      'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a',
      'https://images.unsplash.com/photo-1519642173-84b9ea79d27e',
      'https://images.unsplash.com/photo-1567958451986-2de427a4a0be',
      'https://images.unsplash.com/photo-1582719201952-9c19e27dc6da'
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 7,
    title: 'Shopping Colombo - Renovação Completa',
    category: 'comercial',
    description: 'Modernização total do sistema de iluminação do maior centro comercial da Península Ibérica.',
    image: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a',
    year: '2024',
    location: 'Lisboa, Portugal',
    area: '120.000 m²',
    budget: '€2.500.000',
    duration: '12 meses',
    client: 'Sonae Sierra',
    fullDescription: 'Projeto de modernização integral de iluminação para o Shopping Colombo. O maior desafio foi executar a renovação de toda a iluminação das áreas comuns e praças de alimentação sem interromper a operação do centro comercial. Implementamos soluções LED de alta performance e sistemas de controlo inteligentes.',
    challenge: 'Renovação total de um espaço de 120.000 m² mantendo a operação total do shopping e garantindo a segurança de milhares de visitantes diários.',
    solution: 'Planeamento logístico rigoroso com trabalhos executados exclusivamente em horário pós-fecho, uso de equipamentos de acesso especiais e sistema de controlo por zonas.',
    materials: [
      { name: 'Luminárias Lineares LED High-Flow', quantity: '1.200 unidades', specs: 'Eficiência 160lm/W' },
      { name: 'Downlights LED de Alta Potência', quantity: '850 unidades', specs: 'UGR <19' },
      { name: 'Sistemas de Controlo Inteligente', quantity: '1 sistema', specs: 'Integração DALI' }
    ],
    results: [
      'Redução do consumo energético em 65%',
      'Melhoria estética significativa das áreas comuns',
      'Conclusão do projeto dentro do prazo e orçamento',
      'Feedback extremamente positivo dos lojistas'
    ],
    images: [
      'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a',
      'https://images.unsplash.com/photo-1519642173-84b9ea79d27e',
      'https://images.unsplash.com/photo-1567958451986-2de427a4a0be'
    ]
  },
  {
    id: 8,
    title: 'Biblioteca Nacional - Iluminação Patrimonial',
    category: 'institucional',
    description: 'Projeto sensível de iluminação que preserva e valoriza o património histórico.',
    image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570',
    year: '2023',
    location: 'Lisboa, Portugal',
    area: '8.500 m²',
    budget: '€380.000',
    duration: '5 meses',
    client: 'Ministério da Cultura',
    fullDescription: 'Iluminação técnica e arquitetônica para a Biblioteca Nacional de Portugal. O projeto focou na preservação dos acervos, utilizando iluminação sem radiação UV e infravermelha, ao mesmo tempo que valoriza a arquitetura solene do edifício.',
    challenge: 'Garantir níveis de iluminância para leitura sem danificar livros raros e documentos históricos sensíveis à luz.',
    solution: 'Instalação de LEDs com filtros especiais e temperatura de cor quente (2700K), combinando luz indireta para os espaços de leitura.',
    materials: [
      { name: 'LEDs de Conservação Museológica', quantity: '240 unidades', specs: 'Zero UV/IR, CRI >95' },
      { name: 'Sistemas de Iluminação Indireta', quantity: '120 metros', specs: 'Luz difusa e uniforme' }
    ],
    results: [
      'Proteção total do património histórico',
      'Melhoria do conforto visual para leitores e investigadores',
      'Eficiência energética acrescida'
    ],
    images: [
      'https://images.unsplash.com/photo-1481627834876-b7833e8f5570',
      'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f'
    ]
  },
  {
    id: 9,
    title: 'Estádio do Dragão - Iluminação Desportiva',
    category: 'institucional',
    description: 'Sistema de iluminação LED para transmissões HD e eventos noturnos.',
    image: 'https://images.unsplash.com/photo-1459865264687-595d652de67e',
    year: '2024',
    location: 'Porto, Portugal',
    area: '52.000 m²',
    budget: '€1.800.000',
    duration: '8 meses',
    client: 'FC Porto',
    fullDescription: 'Upgrade do sistema de iluminação do campo principal para tecnologia LED de alta potência, cumprindo os rigorosos requisitos da UEFA Elite para transmissões televisivas 4K/UHD.',
    challenge: 'Atingir níveis de uniformidade e verticalidade de luz extremamente elevados necessários para transmissões HD, minimizando o encandeamento.',
    solution: 'Uso de projetores LED de última geração com óticas de precisão e sistema de controlo de alta velocidade para efeitos de entretenimento.',
    materials: [
      { name: 'Projetores LED de Arena 1200W', quantity: '210 unidades', specs: 'TLCI >90, Flicker-free' },
      { name: 'Sistema de Controlo Show-Light', quantity: '1 sistema', specs: 'Sincronização áudio/luz' }
    ],
    results: [
      'Conformidade total com requisitos UEFA Elite',
      'Possibilidade de shows de luzes dinâmicos',
      'Redução de 50% na carga elétrica instalada'
    ],
    images: [
      'https://images.unsplash.com/photo-1459865264687-595d652de67e',
      'https://images.unsplash.com/photo-1540747913346-19e3ad6436b1'
    ]
  }
];

export const products = [
  {
    id: 1,
    name: 'Painel LED Slim',
    category: 'Iluminação Interior',
    description: 'Painéis LED ultra-finos para tetos falsos. Perfeitos para escritórios, hospitais e escolas.',
    image: 'https://images.unsplash.com/photo-1767294273869-d7d15bc5f80d',
    features: ['Alta eficiência energética', 'Luz uniforme', 'Instalação rápida'],
    applications: ['Escritórios', 'Hospitais', 'Escolas']
  },
  {
    id: 2,
    name: 'Candeeiro Suspenso Moderno',
    category: 'Iluminação Decorativa',
    description: 'Luminárias suspensas de design contemporâneo para espaços comerciais e institucionais.',
    image: 'https://images.unsplash.com/photo-1589173956121-8891103b66b0',
    features: ['Design elegante', 'Várias cores disponíveis', 'Tecnologia LED'],
    applications: ['Hotéis', 'Restaurantes', 'Lobbies']
  },
  {
    id: 3,
    name: 'Sistema LED Linear',
    category: 'Iluminação Técnica',
    description: 'Perfis LED lineares modulares para iluminação contínua em grandes espaços.',
    image: 'https://images.unsplash.com/photo-1652814079644-6f9bd42034bf',
    features: ['Modular', 'Fluxo contínuo', 'Controlo DALI'],
    applications: ['Centros Comerciais', 'Aeroportos', 'Museus']
  },
  {
    id: 4,
    name: 'Downlight Embutido',
    category: 'Iluminação Interior',
    description: 'Focos embutidos de alta performance com ângulos de abertura ajustáveis.',
    image: 'https://images.unsplash.com/photo-1674849665344-944d468883d0',
    features: ['Anti-encandeamento', 'Dimmerizável', 'IP44'],
    applications: ['Casas de Banho', 'Cozinhas', 'Corredores']
  },
  {
    id: 5,
    name: 'Luminária Arquitetônica',
    category: 'Iluminação Exterior',
    description: 'Soluções de iluminação para fachadas e monumentos com controlo RGB.',
    image: 'https://images.unsplash.com/photo-1771239048280-0724031de3a4',
    features: ['RGB+W', 'IP65', 'Controlo DMX'],
    applications: ['Fachadas', 'Monumentos', 'Paisagismo']
  },
  {
    id: 6,
    name: 'Sistema de Gestão Inteligente',
    category: 'Controlo e Automação',
    description: 'Plataforma completa para gestão centralizada de sistemas de iluminação.',
    image: 'https://images.unsplash.com/photo-1708172180685-91cbd7dff647',
    features: ['App mobile', 'Sensores integrados', 'Relatórios de consumo'],
    applications: ['Edifícios Corporativos', 'Hospitais', 'Universidades']
  }
];

export const services = [
  {
    id: 1,
    title: 'Consultoria e Design',
    description: 'Desenvolvimento de projetos de iluminação personalizados para cada tipo de espaço.',
    icon: 'Lightbulb'
  },
  {
    id: 2,
    title: 'Fornecimento de Material',
    description: 'Amplo catálogo de produtos de marcas líderes no mercado de iluminação profissional.',
    icon: 'Package'
  },
  {
    id: 3,
    title: 'Gestão de Projeto',
    description: 'Acompanhamento completo desde o planeamento até à instalação final.',
    icon: 'ClipboardCheck'
  },
  {
    id: 4,
    title: 'Eficiência Energética',
    description: 'Soluções que reduzem o consumo energético e os custos operacionais.',
    icon: 'Zap'
  }
];

export const stats = [
  { number: '150+', label: 'Projetos Concluídos' },
  { number: '50+', label: 'Clientes Satisfeitos' },
  { number: '15', label: 'Anos de Experiência' },
  { number: '100%', label: 'Taxa de Satisfação' }
];

export const companyInfo = {
  name: 'LuxDall',
  legalName: 'LuxDall',
  email: 'geral@luxdall.pt',
  projectsEmail: 'projetos@luxdall.pt',
  phone: '+351 234 136 136',
  address: 'R. Celestino Neto 17 1ºA, 3750-101 Águeda',
  description: 'A LuxDall é uma empresa especializada em gestão de projetos de iluminação para grandes obras. Fornecemos soluções completas de iluminação para hospitais, centros de artes, escolas e universidades, trabalhando em parceria com empresas de construção em todo o país.',
  mission: 'Fornecer soluções de iluminação inovadoras e eficientes que transformam espaços e melhoram a qualidade de vida das pessoas.',
  values: [
    'Qualidade e excelência em cada projeto',
    'Compromisso com a sustentabilidade',
    'Inovação tecnológica constante',
    'Parceria e transparência com clientes'
  ]
};
